import Vue from 'vue'
import VueRouter from 'vue-router'
import {commonRouter} from "./routes"
import {getStorage} from '@/storage'
import store from "@/store/index"
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: commonRouter
})

function filterRoutes(routes, roleType) {
  return routes.filter(route => {
    if (route.path === '/login' || route.path === '*' || route.path === '/') {
      return true
    }
    if (!route.meta || !route.meta.roles) {
      return true
    }
    if (route.meta.roles.includes(roleType)) {
      if (route.children && route.children.length > 0) {
        route.children = filterRoutes(route.children, roleType)
      }
      return true
    }
    return false
  })
}

router.beforeEach((to, from, next) => {
  console.log(to)
  if(getStorage('token')){
    if (to.path === "/login") {
      const roleType = getStorage('roleType')
      if (roleType === 2) {
        next('/agent')
      } else if (roleType === 3) {
        next('/company')
      } else {
        next('/home')
      }
    } else {
      next()
    }
  } else {
    to.path === "/login" ? next() : next('/login')
  }
})

export function resetRouter(roleType) {
  const newRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: commonRouter
  })
  const filteredRoutes = filterRoutes([...commonRouter], roleType)
  router.matcher = newRouter.matcher
  router.addRoutes(filteredRoutes)
}

export default router
